export default __webpack_public_path__ + "static/media/ROX_4815.833c3d8a.jpg";